// extracted by mini-css-extract-plugin
module.exports = {"background":"Main_background__2X73r","background__content":"Main_background__content__1UMKD","link":"Main_link__2R6Tn"};